import { algoliasearch } from 'algoliasearch';

const algoliaApplicationId = process.env.REACT_APP_ALGOLIA_APPLICATION_ID;
const algoliaApiKey = process.env.REACT_APP_ALGOLIA_API_KEY;

export const isAlgoliaConfigured = Boolean(algoliaApplicationId && algoliaApiKey);

let client = null;
if (isAlgoliaConfigured) {
    client = algoliasearch(
        algoliaApplicationId,
        algoliaApiKey,
    );
} else {
    console.warn('Algolia is not configured. Please set REACT_APP_ALGOLIA_APPLICATION_ID and REACT_APP_ALGOLIA_API_KEY in your .env file.');
}

export const ITEMS_PER_PAGE = 30;

export default client;